module.exports = __webpack_public_path__ + "static/media/abadgaran.f069e276.png";